import { UiTextFieldV2 } from "@smp/ui";
import { useField } from "formik";
import { useMemo } from "react";

import { IFormTextFieldV2Props } from "./form_text_field_v2.types";

export const FormTextFieldV2 = ({ name, ...props }: IFormTextFieldV2Props) => {
  const [field, meta] = useField(name);

  return useMemo(
    () => (
      <UiTextFieldV2
        error={!!meta.touched && !!meta.error}
        errorMessage={
          !!meta.touched ? (meta.error ? meta.error : undefined) : undefined
        }
        {...field}
        {...props}
      />
    ),
    [field, meta.error, meta.touched, props],
  );
};
